import { WindowsIcon } from "@flat-ui";

/** Type representing the different operating systems for the Exporter app */

/** Interface representing the data for each Exporter app operating system */

const WINDOWS_DATA = {
  system: "windows-64bit",
  downloadUrl: "https://uploads.holobuilder.com/apps/downloader_app/SphereXGDownloader-Windows.zip",
  name: "Windows (64-bit)",
  icon: <WindowsIcon sx={{
    width: "20px",
    height: "20px"
  }} />
};

// TODO: Currently the macOS apps are not working as expected. They won't be listed in the UI until they are fixed.
// const MAC_ARM_DATA: ExporterAppOSData = {
//   system: "mac-arm",
//   downloadUrl: "https://uploads.holobuilder.com/apps/downloader_app/SphereXGDownloader-macOS-arm.zip",
//   name: "Mac (Apple Silicon)",
//   icon: <AppleIcon sx={{ width: "20px", height: "20px" }} />,
// };
// const MAC_INTEL_DATA: ExporterAppOSData = {
//   system: "mac-intel",
//   downloadUrl: "https://uploads.holobuilder.com/apps/downloader_app/SphereXGDownloader-macOS.zip",
//   name: "Mac (Intel)",
//   icon: <AppleIcon sx={{ width: "20px", height: "20px" }} />,
// };

/** Data for each Exporter app operating system */
export const EXPORTER_APP_OS_DATA = {
  ["windows-64bit"]: WINDOWS_DATA
};